import { ContentHeader, LayoutWithNavigationBreadcrumbs } from 'components';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import {
  DirectoryRecordForm,
  FormContent,
  type DirectoryRecordFormProps,
  type FormContentProps,
} from 'modules/directory/common/components';

import { CreatableFormFooter } from '../components';

interface CreateDirectoryRecordViewProps
  extends DirectoryRecordFormProps,
    FormContentProps {
  directoryName?: string;
  submitLoading: boolean;
}

export const CreateDirectoryRecordView = ({
  directoryName,
  fieldsConfig,
  record,
  submitLoading,
  ...formProps
}: CreateDirectoryRecordViewProps) => {
  const { t } = useTranslation();

  return (
    <LayoutWithNavigationBreadcrumbs
      titles={{
        [RoutesId.directory]: directoryName,
        [RoutesId.createDirectoryRecord]: t('directory.addDialog.title'),
      }}
    >
      <DirectoryRecordForm {...formProps}>
        <ContentHeader header={t('directory.addDialog.title')} />
        <FormContent fieldsConfig={fieldsConfig} />
        <CreatableFormFooter submitLoading={submitLoading} />
      </DirectoryRecordForm>
    </LayoutWithNavigationBreadcrumbs>
  );
};
